import { gql } from "@apollo/client";

const GET_COMPANY = gql`
    query GetCompany($ruc: String!) {
        empresa(ruc: $ruc) {
            ruc
            razonSocial
        }
    }
`;

export default GET_COMPANY;
